import React, { useMemo, useState } from 'react';
import cn from 'classnames';

export interface NumberInputProps {
  value: number | undefined;
  onUpdate: (newValue: number | undefined) => void;
  placeholder: string;
  showErrorHint: boolean;
}

const toWorkingValue = (current: number | undefined): string => {
  return current === undefined ? '' : current.toString(10);
};

export const NumberInput: React.FC<NumberInputProps> = ({
  value,
  onUpdate,
  placeholder,
  showErrorHint,
}) => {
  const [workingValue, setWorkingValue] = useState(toWorkingValue(value));

  const workingValueAsNumber = useMemo(() => {
    try {
      return parseFloat(workingValue);
    } catch {
      return undefined;
    }
  }, [workingValue]);

  return (
    <input
      type="text"
      value={workingValue}
      className={cn('form-input ml-2', {
        'border-red-500': showErrorHint,
      })}
      onFocus={() => {
        const newWorkingValue = toWorkingValue(value);
        if (newWorkingValue !== workingValue) {
          setWorkingValue(newWorkingValue);
        }
      }}
      onBlur={() => {
        if (workingValue.trim() === '' && value !== undefined) {
          onUpdate(undefined);
        } else if (
          workingValueAsNumber !== undefined &&
          !isNaN(workingValueAsNumber) &&
          isFinite(workingValueAsNumber)
        ) {
          onUpdate(workingValueAsNumber);
          setWorkingValue(toWorkingValue(workingValueAsNumber));
        } else {
          // Set the value back, since it is now invalid.
          setWorkingValue(toWorkingValue(value));
        }
      }}
      onChange={(event) => {
        setWorkingValue(event.target.value);
      }}
      placeholder={placeholder}
    />
  );
};
